
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-regular-svg-icons';
import Button from '../../../common/button/Button';
import formatDateToBR from '../../../utils/formatDateToBR';
import CalculateTimeSeconds from '../../../utils/calculateTimeSeconds';
// import PlaceholderImage from '../../../common/placeholderImage/PlaceholderImage';
// import Slider from '../../../common/Slider/Slider';

const NewsSlider = memo(({
    // slidesToShowExtraSmall = 2,
    // slidesToShowSmall = 3,
    // slidesToShowMedium = 4,
    // slidesToShowLarge = 5,
    // slidesToShowExtraLarge = 6,
    title,
    news,
    // autoplay,
    withBackground,
}) =>

// const breakpoints = {
//     640: {
//         slidesPerView: slidesToShowSmall,
//     },
//     768: {
//         slidesPerView: slidesToShowMedium,
//     },
//     1024: {
//         slidesPerView: slidesToShowLarge,
//     },
//     1199: {
//         slidesPerView: slidesToShowExtraLarge,
//     },
// };

// eslint-disable-next-line implicit-arrow-linebreak
    (
        <div className={`additionalNewsSection${withBackground ? ' withBackground' : ''}`}>
            {title &&
            <header className="tw-border-t tw-border-b tw-border-black tw-py-2 tw-px-0">
                <h2 className="tw-text-left tw-m-0 tw-text-black tw-capitalize">
                    {title}
                </h2>
            </header>}
            <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 xl:tw-grid-cols-4 tw-gap-2 md:tw-gap-6 lg:tw-gap-10 tw-auto-rows-fr">
                {news && news.length > 0 ?
                    news.map((item) => {
                        const imageSrc =
                        item.imageNew
                            ? `https://a1media.antena1.com.br/image/news/482x250/${item.imageNew}`
                            : `https://a1media.antena1.com.br/image/news/${item.imageLink}`;

                        return (
                            <div key={item.slug}>
                                <Button className="blockNewsSlide" title={item.title} to={`/noticias/${item.slug}`} route={item.slug}>
                                    <article>
                                        <div className="newsDate tw-flex tw-justify-between">
                                            <p>
                                                {formatDateToBR(item.date)}
                                            </p>

                                            <span className="tw-flex tw-items-center">
                                                <div>
                                                    <FontAwesomeIcon icon={faClock} className="faNewsItem" width="16" />
                                                </div>
                                                <div className="tw-ml-1">
                                                    <CalculateTimeSeconds dateToFormat={item.date} />
                                                </div>
                                            </span>
                                        </div>
                                        <div>
                                            <h3 className="limitText2 tw-text-xl tw-text-left tw-font-bold tw-text-gray-800 tw-mb-4">
                                                {item.title}
                                            </h3>
                                        </div>
                                        <div className="newsImage tw-w-full">
                                            <img src={imageSrc} alt={item.title} className="tw-w-full" />
                                        </div>
                                        <div className="newsDescription">
                                            <p className="limitText2">
                                                {item.subtitle}
                                            </p>
                                        </div>
                                    </article>
                                </Button>
                            </div>
                        );
                    })
                    : []}
            </div>
        </div>
    ),
);

NewsSlider.propTypes = exact({
    title: PropTypes.string,
    // slidesToShowExtraSmall: PropTypes.number,
    // slidesToShowSmall: PropTypes.number,
    // slidesToShowMedium: PropTypes.number,
    // slidesToShowLarge: PropTypes.number,
    // slidesToShowExtraLarge: PropTypes.number,
    news: PropTypes.array,
    // autoplay: PropTypes.object,
    withBackground: PropTypes.bool,
});

export default NewsSlider;
